import { createEnquiryLogic } from './createEnquiryLogic';

export const logic = [createEnquiryLogic];
